/*
* 慧停车
* */
const PayProtocol = () => import('@/components/protocol/witparking/Pay/PayProtocol');
const RegisterProtocol = () => import('@/components/protocol/witparking/Register/RegisterProtocol');
const FingerPrintProtocol = () => import('@/components/protocol/witparking/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol = () => import('@/components/protocol/witparking/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol = () => import('@/components/protocol/witparking/LongRent/LongRentProtocol');
const SharedProtocol = () => import('@/components/protocol/witparking/Shared/SharedProtocol');
const PrivacyProtocol = () => import('@/components/protocol/witparking/Privacy/Privacy');
const RechargeRegistrationProtocol = () => import('@/components/protocol/witparking/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx = () => import('@/components/protocol/witparking/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol = () => import('@/components/protocol/witparking/Verified/VerifiedProtocol');
const AccountCancellation = () => import('@/components/protocol/witparking/AccountCancellation/AccountCancellation');
const MerchantServices = () => import('@/components/protocol/witparking/MerchantServices/MerchantServices');//慧停车商户小程序服务协议
const OpenElePurseProtocol = () => import('@/components/protocol/witparking/OpenElePurse/OpenElePurseProtocol');
/*
* 淄博慧停车
* */
const PayProtocol_zibo = () => import('@/components/protocol/zibo/Pay/PayProtocol');
const RegisterProtocol_zibo = () => import('@/components/protocol/zibo/Register/RegisterProtocol');
const FingerPrintProtocol_zibo = () => import('@/components/protocol/zibo/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_zibo = () => import('@/components/protocol/zibo/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_zibo = () => import('@/components/protocol/zibo/LongRent/LongRentProtocol');
const SharedProtocol_zibo = () => import('@/components/protocol/zibo/Shared/SharedProtocol');
const PrivacyProtocol_zibo = () => import('@/components/protocol/zibo/Privacy/Privacy');
const RechargeRegistrationProtocol_zibo = () => import('@/components/protocol/zibo/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx_zibo = () => import('@/components/protocol/zibo/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol_zibo = () => import('@/components/protocol/zibo/Verified/VerifiedProtocol');
const AccountCancellation_zibo = () => import('@/components/protocol/zibo/AccountCancellation/AccountCancellation');
/*
* 聊城慧停车
* */
const PayProtocol_liaocheng = () => import('@/components/protocol/liaocheng/Pay/PayProtocol');
const RegisterProtocol_liaocheng = () => import('@/components/protocol/liaocheng/Register/RegisterProtocol');
const FingerPrintProtocol_liaocheng = () => import('@/components/protocol/liaocheng/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_liaocheng = () => import('@/components/protocol/liaocheng/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_liaocheng = () => import('@/components/protocol/liaocheng/LongRent/LongRentProtocol');
const SharedProtocol_liaocheng = () => import('@/components/protocol/liaocheng/Shared/SharedProtocol');
const PrivacyProtocol_liaocheng = () => import('@/components/protocol/liaocheng/Privacy/Privacy');
const RechargeRegistrationProtocol_liaocheng = () => import('@/components/protocol/liaocheng/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx_liaocheng = () => import('@/components/protocol/liaocheng/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol_liaocheng = () => import('@/components/protocol/liaocheng/Verified/VerifiedProtocol');
const AccountCancellation_liaocheng = () => import('@/components/protocol/liaocheng/AccountCancellation/AccountCancellation');
/*
* 雄关
* */
const PayProtocol_xiongguan = () => import('@/components/protocol/xiongguan/Pay/PayProtocol');
const RegisterProtocol_xiongguan = () => import('@/components/protocol/xiongguan/Register/RegisterProtocol');
const FingerPrintProtocol_xiongguan = () => import('@/components/protocol/xiongguan/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_xiongguan = () => import('@/components/protocol/xiongguan/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_xiongguan = () => import('@/components/protocol/xiongguan/LongRent/LongRentProtocol');
const SharedProtocol_xiongguan = () => import('@/components/protocol/xiongguan/Shared/SharedProtocol');
const PrivacyProtocol_xiongguan = () => import('@/components/protocol/xiongguan/Privacy/Privacy');
const RechargeRegistrationProtocol_xiongguan = () => import('@/components/protocol/xiongguan/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx_xiongguan = () => import('@/components/protocol/xiongguan/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol_xiongguan = () => import('@/components/protocol/xiongguan/Verified/VerifiedProtocol');
const AccountCancellation_xiongguan = () => import('@/components/protocol/xiongguan/AccountCancellation/AccountCancellation');

/*
* 青岛慧停车
* */
const PayProtocol_qingdao = () => import('@/components/protocol/qingdao/Pay/PayProtocol');
const RegisterProtocol_qingdao = () => import('@/components/protocol/qingdao/Register/RegisterProtocol');
const FingerPrintProtocol_qingdao = () => import('@/components/protocol/qingdao/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_qingdao = () => import('@/components/protocol/qingdao/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_qingdao = () => import('@/components/protocol/qingdao/LongRent/LongRentProtocol');
const SharedProtocol_qingdao = () => import('@/components/protocol/qingdao/Shared/SharedProtocol');
const PrivacyProtocol_qingdao = () => import('@/components/protocol/qingdao/Privacy/Privacy');
/*
* 重庆慧停车
* */
const PayProtocol_chongqing = () => import('@/components/protocol/chongqing/Pay/PayProtocol');
const RegisterProtocol_chongqing = () => import('@/components/protocol/chongqing/Register/RegisterProtocol');
const FingerPrintProtocol_chongqing = () => import('@/components/protocol/chongqing/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_chongqing = () => import('@/components/protocol/chongqing/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_chongqing = () => import('@/components/protocol/chongqing/LongRent/LongRentProtocol');
const SharedProtocol_chongqing = () => import('@/components/protocol/chongqing/Shared/SharedProtocol');
const PrivacyProtocol_chongqing = () => import('@/components/protocol/chongqing/Privacy/Privacy');
/*
* 北京慧停车
* */
const PayProtocol_tongzhou = () => import('@/components/protocol/tongzhou/Pay/PayProtocol');
const RegisterProtocol_tongzhou = () => import('@/components/protocol/tongzhou/Register/RegisterProtocol');
const FingerPrintProtocol_tongzhou = () => import('@/components/protocol/tongzhou/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_tongzhou = () => import('@/components/protocol/tongzhou/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_tongzhou = () => import('@/components/protocol/tongzhou/LongRent/LongRentProtocol');
const SharedProtocol_tongzhou = () => import('@/components/protocol/tongzhou/Shared/SharedProtocol');
const PrivacyProtocol_tongzhou = () => import('@/components/protocol/tongzhou/Privacy/Privacy');
/*
* 武威慧停车
* */
const PayProtocol_wuwei = () => import('@/components/protocol/wuwei/Pay/PayProtocol');
const RegisterProtocol_wuwei = () => import('@/components/protocol/wuwei/Register/RegisterProtocol');
const FingerPrintProtocol_wuwei = () => import('@/components/protocol/wuwei/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_wuwei = () => import('@/components/protocol/wuwei/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_wuwei = () => import('@/components/protocol/wuwei/LongRent/LongRentProtocol');
const SharedProtocol_wuwei = () => import('@/components/protocol/wuwei/Shared/SharedProtocol');
const PrivacyProtocol_wuwei = () => import('@/components/protocol/wuwei/Privacy/Privacy');
const VerifiedProtocol_wuwei = () => import('@/components/protocol/wuwei/VerifiedProtocol/VerifiedProtocol');
const AccountCancellation_wuwei = () => import('@/components/protocol/wuwei/AccountCancellation/AccountCancellation');
const MerchantServices_wuwei = () => import('@/components/protocol/wuwei/MerchantServices/MerchantServices');
const RechargeRegistration_wuwei = () => import('@/components/protocol/wuwei/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationWx_wuwei = () => import('@/components/protocol/wuwei/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
/*
* 金山慧停车
* */
const RechargeRegistrationProtocolWxJs = () => import('@/components/protocol/jinshan/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const LongRentProtocol_jinshan = () => import('@/components/protocol/jinshan/LongRent/LongRentProtocol');
const PrivacyProtocol_jinshan = () => import('@/components/protocol/jinshan/Privacy/Privacy');
const QuickPaymentProtocol_jinshan = () => import('@/components/protocol/jinshan/QuickPayment/QuickPaymentProtocol');
const RegisterProtocol_jinshan = () => import('@/components/protocol/jinshan/Register/RegisterProtocol');
const SharedProtocol_jinshan = () => import('@/components/protocol/jinshan/Shared/SharedProtocol');
const VerifiedProtocol_jinshan  = () => import('@/components/protocol/jinshan/Verified/VerifiedProtocol');

/*
* 桐庐慧停车
* */
const RechargeRegistrationProtocolWxTl = () => import('@/components/protocol/tonglu/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const LongRentProtocol_tonglu = () => import('@/components/protocol/tonglu/LongRent/LongRentProtocol');
const PrivacyProtocol_tonglu = () => import('@/components/protocol/tonglu/Privacy/Privacy');
const QuickPaymentProtocol_tonglu = () => import('@/components/protocol/tonglu/QuickPayment/QuickPaymentProtocol');
const RegisterProtocol_tonglu = () => import('@/components/protocol/tonglu/Register/RegisterProtocol');
const SharedProtocol_tonglu = () => import('@/components/protocol/tonglu/Shared/SharedProtocol');
const VerifiedProtocol_tonglu  = () => import('@/components/protocol/tonglu/Verified/VerifiedProtocol');
/*
* 三明智慧停车
* */
const RechargeRegistrationProtocolWxSM = () => import('@/components/protocol/sanming/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const LongRentProtocol_sanming = () => import('@/components/protocol/sanming/LongRent/LongRentProtocol');
const PrivacyProtocol_sanming = () => import('@/components/protocol/sanming/Privacy/Privacy');
const QuickPaymentProtocol_sanming = () => import('@/components/protocol/sanming/QuickPayment/QuickPaymentProtocol');
const RegisterProtocol_sanming = () => import('@/components/protocol/sanming/Register/RegisterProtocol');
const SharedProtocol_sanming = () => import('@/components/protocol/sanming/Shared/SharedProtocol');
const VerifiedProtocol_sanming  = () => import('@/components/protocol/sanming/Verified/VerifiedProtocol');

/*
* 青岛慧停车
* */
const LongRentProtocol_qdsz = () => import('@/components/protocol/qdsz/LongRent/LongRentProtocol');
const PrivacyProtocol_qdsz = () => import('@/components/protocol/qdsz/Privacy/Privacy');
const QuickPaymentProtocol_qdsz = () => import('@/components/protocol/qdsz/QuickPayment/QuickPaymentProtocol');
const RegisterProtocol_qdsz = () => import('@/components/protocol/qdsz/Register/RegisterProtocol');
const SharedProtocol_qdsz = () => import('@/components/protocol/qdsz/Shared/SharedProtocol');
const VerifiedProtocol_qdsz  = () => import('@/components/protocol/qdsz/Verified/VerifiedProtocol');
const AccountCancellation_qdsz  = () => import('@/components/protocol/qdsz/AccountCancellation/AccountCancellation');
/*
慧停车运维APP
* */
const PrivacyProtocolOm = () => import('@/components/protocol/witparking_om/Privacy/Privacy');

/*
慧安佳APP
* */
const PrivacyProtocolCommunity = () => import('@/components/protocol/witparking_community/Privacy/Privacy');
const PrivacyProtocolCommunity_service = () => import('@/components/protocol/witparking_community/RechargeRegistrationProtocol/RechargeRegistrationProtocol');
//和美天山协议
const PrivacyProtocol_hmts = () => import('@/components/protocol/hmts/index');
//臻美太湖协议
const PrivacyProtocol_zmth = () => import('@/components/protocol/zmth/index');
//慧安佳小程序
const PrivacyProtocol_haj = () => import('@/components/protocol/hajmin/index');
//慧安佳便捷通行小程序
const PrivacyProtocol_hajbjtx = () => import('@/components/protocol/hajmin/bjtx');
// 渭源智慧泊车小程序
const VerifiedProtocol_weiyuan = () => import('@/components/protocol/weiyuan/Verified/VerifiedProtocol');
const UserProtocol_weiyuan = () => import('@/components/protocol/weiyuan/User/userProtocol');
/*
* 市南慧停车APP
* */
const PayProtocol_shinan = () => import('@/components/protocol/shinan/Pay/PayProtocol');
const RegisterProtocol_shinan = () => import('@/components/protocol/shinan/Register/RegisterProtocol');
const FingerPrintProtocol_shinan = () => import('@/components/protocol/shinan/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_shinan = () => import('@/components/protocol/shinan/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_shinan = () => import('@/components/protocol/shinan/LongRent/LongRentProtocol');
const SharedProtocol_shinan = () => import('@/components/protocol/shinan/Shared/SharedProtocol');
const PrivacyProtocol_shinan = () => import('@/components/protocol/shinan/Privacy/Privacy');
const RechargeRegistrationProtocol_shinan = () => import('@/components/protocol/shinan/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx_shinan = () => import('@/components/protocol/shinan/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol_shinan = () => import('@/components/protocol/shinan/Verified/VerifiedProtocol');
const AccountCancellation_shinan = () => import('@/components/protocol/shinan/AccountCancellation/AccountCancellation');
const MerchantServices_shinan = () => import('@/components/protocol/shinan/MerchantServices/MerchantServices');//慧停车商户小程序服务协议
const OpenElePurseProtocol_shinan = () => import('@/components/protocol/shinan/OpenElePurse/OpenElePurseProtocol');
/*
* 金昌慧停车
* */
const PayProtocol_jinchang = () => import('@/components/protocol/jinchang/Pay/PayProtocol');
const RegisterProtocol_jinchang = () => import('@/components/protocol/jinchang/Register/RegisterProtocol');
const FingerPrintProtocol_jinchang = () => import('@/components/protocol/jinchang/FingerPrint/FingerPrintProtocol');
const QuickPaymentProtocol_jinchang = () => import('@/components/protocol/jinchang/QuickPayment/QuickPaymentProtocol');
const LongRentProtocol_jinchang = () => import('@/components/protocol/jinchang/LongRent/LongRentProtocol');
const SharedProtocol_jinchang = () => import('@/components/protocol/jinchang/Shared/SharedProtocol');
const PrivacyProtocol_jinchang = () => import('@/components/protocol/jinchang/Privacy/Privacy');
const RechargeRegistrationProtocol_jinchang = () => import('@/components/protocol/jinchang/RechargeRegistration/RechargeRegistrationProtocol');
const RechargeRegistrationProtocolWx_jinchang = () => import('@/components/protocol/jinchang/RechargeRegistrationWx/RechargeRegistrationProtocolWx');
const VerifiedProtocol_jinchang = () => import('@/components/protocol/jinchang/Verified/VerifiedProtocol');
const AccountCancellation_jinchang = () => import('@/components/protocol/jinchang/AccountCancellation/AccountCancellation');
const MerchantServices_jinchang = () => import('@/components/protocol/jinchang/MerchantServices/MerchantServices');
const AuthorizedInformation_jinchang = () => import('@/components/protocol/jinchang/AuthorizedInformation/AuthorizedInformation');
const TripartiteSDK_jinchang = () => import('@/components/protocol/jinchang/TripartiteSDK/TripartiteSDK');
/* 金昌慧停车运维APP*/
const PrivacyProtocol_jinchangOm = () => import('@/components/protocol/jinchang_om/Privacy/Privacy');
let ProtocolRouters = {
  /*
  * 慧停车
  * */
  witparking: {
    PayProtocol: {
      path: '/witparking/PayProtocol',
      component: PayProtocol,
    },
    RegisterProtocol: {
      path: '/witparking/RegisterProtocol',
      component: RegisterProtocol,
    },
    QuickPaymentProtocol: {
      path: '/witparking/QuickPaymentProtocol',
      component: QuickPaymentProtocol,
    },
    FingerPrintProtocol: {
      path: '/witparking/FingerPrintProtocol',
      component: FingerPrintProtocol,
    },
    LongRentProtocol: {
      path: '/witparking/LongRentProtocol',
      component: LongRentProtocol,
    },
    SharedProtocol: {
      path: '/witparking/SharedProtocol',
      component: SharedProtocol,
    },
    PrivacyProtocol: {
      path: '/witparking/PrivacyProtocol',
      component: PrivacyProtocol,
    },
    RechargeRegistrationProtocol: {
      path: '/witparking/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol,
    },
    VerifiedProtocol:{
      path: '/witparking/VerifiedProtocol',
      component: VerifiedProtocol,
    },
    RechargeRegistrationProtocolWx: {
      path: '/witparking/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx,
    },
    AccountCancellation: {
      path: '/witparking/AccountCancellation',
      component: AccountCancellation,
    },
    MerchantServices: {
      path: '/witparking/MerchantServices',
      component: MerchantServices,
    },
    OpenElePurseProtocol: {
      path: '/witparking/OpenElePurseProtocol',
      component: OpenElePurseProtocol,
    },
  },

   /*
  * 淄博慧停车
  * */
  zibo: {
    PayProtocol: {
      path: '/zibo/PayProtocol',
      component: PayProtocol_zibo,
    },
    RegisterProtocol: {
      path: '/zibo/RegisterProtocol',
      component: RegisterProtocol_zibo,
    },
    QuickPaymentProtocol: {
      path: '/zibo/QuickPaymentProtocol',
      component: QuickPaymentProtocol_zibo,
    },
    FingerPrintProtocol: {
      path: '/zibo/FingerPrintProtocol',
      component: FingerPrintProtocol_zibo,
    },
    LongRentProtocol: {
      path: '/zibo/LongRentProtocol',
      component: LongRentProtocol_zibo,
    },
    SharedProtocol: {
      path: '/zibo/SharedProtocol',
      component: SharedProtocol_zibo,
    },
    PrivacyProtocol: {
      path: '/zibo/PrivacyProtocol',
      component: PrivacyProtocol_zibo,
    },
    RechargeRegistrationProtocol: {
      path: '/zibo/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol_zibo,
    },
    VerifiedProtocol:{
      path: '/zibo/VerifiedProtocol',
      component: VerifiedProtocol_zibo,
    },
    RechargeRegistrationProtocolWx: {
      path: '/zibo/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx_zibo,
    },
    AccountCancellation: {
      path: '/zibo/AccountCancellation',
      component: AccountCancellation_zibo,
    },
  },

  /*
  * 聊城慧停车
  * */
  liaocheng: {
    PayProtocol: {
      path: '/liaocheng/PayProtocol',
      component: PayProtocol_liaocheng,
    },
    RegisterProtocol: {
      path: '/liaocheng/RegisterProtocol',
      component: RegisterProtocol_liaocheng,
    },
    QuickPaymentProtocol: {
      path: '/liaocheng/QuickPaymentProtocol',
      component: QuickPaymentProtocol_liaocheng,
    },
    FingerPrintProtocol: {
      path: '/liaocheng/FingerPrintProtocol',
      component: FingerPrintProtocol_liaocheng,
    },
    LongRentProtocol: {
      path: '/liaocheng/LongRentProtocol',
      component: LongRentProtocol_liaocheng,
    },
    SharedProtocol: {
      path: '/liaocheng/SharedProtocol',
      component: SharedProtocol_liaocheng,
    },
    PrivacyProtocol: {
      path: '/liaocheng/PrivacyProtocol',
      component: PrivacyProtocol_liaocheng,
    },
    RechargeRegistrationProtocol: {
      path: '/liaocheng/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol_liaocheng,
    },
    VerifiedProtocol:{
      path: '/liaocheng/VerifiedProtocol',
      component: VerifiedProtocol_liaocheng,
    },
    RechargeRegistrationProtocolWx: {
      path: '/liaocheng/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx_liaocheng,
    },
    AccountCancellation: {
      path: '/liaocheng/AccountCancellation',
      component: AccountCancellation_liaocheng,
    },
  },

  /*
  * 雄关
  * */
  xiongguan: {
    PayProtocol: {
      path: '/xiongguan/PayProtocol',
      component: PayProtocol_xiongguan,
    },
    RegisterProtocol: {
      path: '/xiongguan/RegisterProtocol',
      component: RegisterProtocol_xiongguan,
    },
    QuickPaymentProtocol: {
      path: '/xiongguan/QuickPaymentProtocol',
      component: QuickPaymentProtocol_xiongguan,
    },
    FingerPrintProtocol: {
      path: '/xiongguan/FingerPrintProtocol',
      component: FingerPrintProtocol_xiongguan,
    },
    LongRentProtocol: {
      path: '/xiongguan/LongRentProtocol',
      component: LongRentProtocol_xiongguan,
    },
    SharedProtocol: {
      path: '/xiongguan/SharedProtocol',
      component: SharedProtocol_xiongguan,
    },
    PrivacyProtocol: {
      path: '/xiongguan/PrivacyProtocol',
      component: PrivacyProtocol_xiongguan,
    },
    RechargeRegistrationProtocol: {
      path: '/xiongguan/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol_xiongguan,
    },
    VerifiedProtocol:{
      path: '/xiongguan/VerifiedProtocol',
      component: VerifiedProtocol_xiongguan,
    },
    RechargeRegistrationProtocolWx: {
      path: '/xiongguan/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx_xiongguan,
    },
    AccountCancellation: {
      path: '/xiongguan/AccountCancellation',
      component: AccountCancellation_xiongguan,
    },
  },
  /*
  * 青岛慧停车(older)
  * */
  qingdao: {
    PayProtocol: {
      path: '/qingdao/PayProtocol',
      component: PayProtocol_qingdao,
    },
    RegisterProtocol: {
      path: '/qingdao/RegisterProtocol',
      component: RegisterProtocol_qingdao,
    },
    QuickPaymentProtocol: {
      path: '/qingdao/QuickPaymentProtocol',
      component: QuickPaymentProtocol_qingdao,
    },
    FingerPrintProtocol: {
      path: '/qingdao/FingerPrintProtocol',
      component: FingerPrintProtocol_qingdao,
    },
    LongRentProtocol: {
      path: '/qingdao/LongRentProtocol',
      component: LongRentProtocol_qingdao,
    },
    SharedProtocol: {
      path: '/qingdao/SharedProtocol',
      component: SharedProtocol_qingdao,
    },
    PrivacyProtocol: {
      path: '/qingdao/PrivacyProtocol',
      component: PrivacyProtocol_qingdao,
    }
  },
  /*
    * 重庆慧停车
    * */
  chongqing: {
    PayProtocol: {
      path: '/chongqing/PayProtocol',
      component: PayProtocol_chongqing,
    },
    RegisterProtocol: {
      path: '/chongqing/RegisterProtocol',
      component: RegisterProtocol_chongqing,
    },
    QuickPaymentProtocol: {
      path: '/chongqing/QuickPaymentProtocol',
      component: QuickPaymentProtocol_chongqing,
    },
    FingerPrintProtocol: {
      path: '/chongqing/FingerPrintProtocol',
      component: FingerPrintProtocol_chongqing,
    },
    LongRentProtocol: {
      path: '/chongqing/LongRentProtocol',
      component: LongRentProtocol_chongqing,
    },
    SharedProtocol: {
      path: '/chongqing/SharedProtocol',
      component: SharedProtocol_chongqing,
    },
    PrivacyProtocol: {
      path: '/chongqing/PrivacyProtocol',
      component: PrivacyProtocol_chongqing,
    }
  },
  /*
  * 北京慧停车
  * */
  tongzhou: {
    PayProtocol: {
      path: '/tongzhou/PayProtocol',
      component: PayProtocol_tongzhou,
    },
    RegisterProtocol: {
      path: '/tongzhou/RegisterProtocol',
      component: RegisterProtocol_tongzhou,
    },
    QuickPaymentProtocol: {
      path: '/tongzhou/QuickPaymentProtocol',
      component: QuickPaymentProtocol_tongzhou,
    },
    FingerPrintProtocol: {
      path: '/tongzhou/FingerPrintProtocol',
      component: FingerPrintProtocol_tongzhou,
    },
    LongRentProtocol: {
      path: '/tongzhou/LongRentProtocol',
      component: LongRentProtocol_tongzhou,
    },
    SharedProtocol: {
      path: '/tongzhou/SharedProtocol',
      component: SharedProtocol_tongzhou,
    },
    PrivacyProtocol: {
      path: '/tongzhou/PrivacyProtocol',
      component: PrivacyProtocol_tongzhou,
    }
  },
  /*
* 武威慧停车
* */
  wuwei: {
    PayProtocol: {
      path: '/wuwei/PayProtocol',
      component: PayProtocol_wuwei,
    },
    RegisterProtocol: {
      path: '/wuwei/RegisterProtocol',
      component: RegisterProtocol_wuwei,
    },
    QuickPaymentProtocol: {
      path: '/wuwei/QuickPaymentProtocol',
      component: QuickPaymentProtocol_wuwei,
    },
    FingerPrintProtocol: {
      path: '/wuwei/FingerPrintProtocol',
      component: FingerPrintProtocol_wuwei,
    },
    LongRentProtocol: {
      path: '/wuwei/LongRentProtocol',
      component: LongRentProtocol_wuwei,
    },
    SharedProtocol: {
      path: '/wuwei/SharedProtocol',
      component: SharedProtocol_wuwei,
    },
    PrivacyProtocol: {
      path: '/wuwei/PrivacyProtocol',
      component: PrivacyProtocol_wuwei,
    },
    VerifiedProtocol: {
      path: '/wuwei/VerifiedProtocol',
      component: VerifiedProtocol_wuwei,
    },
    AccountCancellation: {
      path: '/wuwei/AccountCancellation',
      component: AccountCancellation_wuwei,
    },
    MerchantServices: {
      path: '/wuwei/MerchantServices',
      component: MerchantServices_wuwei,
    },
    RechargeRegistration: {
      path: '/wuwei/RechargeRegistration',
      component: RechargeRegistration_wuwei,
    },
    RechargeRegistrationWx: {
      path: '/wuwei/RechargeRegistrationWx',
      component: RechargeRegistrationWx_wuwei,
    },
  },
  /*
* 金山慧停车
* */
  jinshan: {
    RechargeRegistrationProtocolWx: {
      path: '/jinshan/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWxJs,
    },
    LongRentProtocol: {
      path: '/jinshan/LongRentProtocol',
      component: LongRentProtocol_jinshan,
    },
    PrivacyProtocol: {
      path: '/jinshan/PrivacyProtocol',
      component: PrivacyProtocol_jinshan,
    },
    QuickPaymentProtocol: {
      path: '/jinshan/QuickPaymentProtocol',
      component: QuickPaymentProtocol_jinshan,
    },
    RegisterProtocol: {
      path: '/jinshan/RegisterProtocol',
      component: RegisterProtocol_jinshan,
    },
    SharedProtocol: {
      path: '/jinshan/SharedProtocol',
      component: SharedProtocol_jinshan,
    },
    VerifiedProtocol:{
      path: '/jinshan/VerifiedProtocol',
      component: VerifiedProtocol_jinshan,
    },
  },
    /*
* 桐庐慧停车
* */
  tonglu: {
    RechargeRegistrationProtocolWx: {
      path: '/tonglu/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWxTl,
    },
    LongRentProtocol: {
      path: '/tonglu/LongRentProtocol',
      component: LongRentProtocol_tonglu,
    },
    PrivacyProtocol: {
      path: '/tonglu/PrivacyProtocol',
      component: PrivacyProtocol_tonglu,
    },
    QuickPaymentProtocol: {
      path: '/tonglu/QuickPaymentProtocol',
      component: QuickPaymentProtocol_tonglu,
    },
    RegisterProtocol: {
      path: '/tonglu/RegisterProtocol',
      component: RegisterProtocol_tonglu,
    },
    SharedProtocol: {
      path: '/tonglu/SharedProtocol',
      component: SharedProtocol_tonglu,
    },
    VerifiedProtocol:{
      path: '/tonglu/VerifiedProtocol',
      component: VerifiedProtocol_tonglu,
    },
  },
  /*
* 三明
* */
  sanming: {
    RechargeRegistrationProtocolWx: {
      path: '/sanming/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWxSM,
    },
    LongRentProtocol: {
      path: '/sanming/LongRentProtocol',
      component: LongRentProtocol_sanming,
    },
    PrivacyProtocol: {
      path: '/sanming/PrivacyProtocol',
      component: PrivacyProtocol_sanming,
    },
    QuickPaymentProtocol: {
      path: '/sanming/QuickPaymentProtocol',
      component: QuickPaymentProtocol_sanming,
    },
    RegisterProtocol: {
      path: '/sanming/RegisterProtocol',
      component: RegisterProtocol_sanming,
    },
    SharedProtocol: {
      path: '/sanming/SharedProtocol',
      component: SharedProtocol_sanming,
    },
    VerifiedProtocol:{
      path: '/sanming/VerifiedProtocol',
      component: VerifiedProtocol_sanming,
    },
  },
  /*
* 慧停车-运维
* */
  witparkingOm: {

    PrivacyProtocol: {
      path: '/witparkingOm/PrivacyProtocol',
      component: PrivacyProtocolOm,
    },

  }, 
   /*
* 慧安佳APP
* */
  witparkingCommunity: {

    PrivacyProtocol: {
      path: '/witparkingCommunity/PrivacyProtocol',
      component: PrivacyProtocolCommunity,
    },
    ServiceProtocol: {
      path: '/witparkingCommunity/ServiceProtocol',
      component: PrivacyProtocolCommunity_service,
    },

  },
   /*
* 和美天山
* */
  hmts: {

    PrivacyProtocolHmts: {
      path: '/hmts/PrivacyProtocolHmts',
      component: PrivacyProtocol_hmts,
    },

  },
     /*
* 臻美太湖
* */
zmth: {

  PrivacyProtocolZmth: {
    path: '/zmth/PrivacyProtocolZmth',
    component: PrivacyProtocol_zmth,
  },

},
    /*
* 慧安佳小程序
* */
hajmin: {

  PrivacyProtocolHaj: {
    path: '/hajmin/PrivacyProtocolHaj',
    component: PrivacyProtocol_haj,
  },
  PrivacyProtocolHajbjtx: {
    path: '/hajmin/PrivacyProtocolHajbjtx',
    component: PrivacyProtocol_hajbjtx,
  },

},
  /*
* 青岛慧停车（new)
* */
  qdsz: {
    RechargeRegistrationProtocolWx: {
      path: '/qdsz/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWxTl,
    },
    LongRentProtocol: {
      path: '/qdsz/LongRentProtocol',
      component: LongRentProtocol_qdsz,
    },
    PrivacyProtocol: {
      path: '/qdsz/PrivacyProtocol',
      component: PrivacyProtocol_qdsz,
    },
    QuickPaymentProtocol: {
      path: '/qdsz/QuickPaymentProtocol',
      component: QuickPaymentProtocol_qdsz,
    },
    RegisterProtocol: {
      path: '/qdsz/RegisterProtocol',
      component: RegisterProtocol_qdsz,
    },
    SharedProtocol: {
      path: '/qdsz/SharedProtocol',
      component: SharedProtocol_qdsz,
    },
    VerifiedProtocol:{
      path: '/qdsz/VerifiedProtocol',
      component: VerifiedProtocol_qdsz,
    },
    AccountCancellation:{
      path: '/qdsz/AccountCancellation',
      component: AccountCancellation_qdsz,
    },
  },
  /*
* 渭源智慧泊车小程序
* */
  weiyuan: {
    VerifiedProtocol: {
      path: '/weiyuan/VerifiedProtocol',
      component: VerifiedProtocol_weiyuan,
    },
    UserProtocol: {
      path: '/weiyuan/userProtocol',
      component: UserProtocol_weiyuan,
    }
  },
  /*
  * 市南慧停车APP
  * */
  shinan: {
    PayProtocol: {
      path: '/shinan/PayProtocol',
      component: PayProtocol_shinan,
    },
    RegisterProtocol: {
      path: '/shinan/RegisterProtocol',
      component: RegisterProtocol_shinan,
    },
    QuickPaymentProtocol: {
      path: '/shinan/QuickPaymentProtocol',
      component: QuickPaymentProtocol_shinan,
    },
    FingerPrintProtocol: {
      path: '/shinan/FingerPrintProtocol',
      component: FingerPrintProtocol_shinan,
    },
    LongRentProtocol: {
      path: '/shinan/LongRentProtocol',
      component: LongRentProtocol_shinan,
    },
    SharedProtocol: {
      path: '/shinan/SharedProtocol',
      component: SharedProtocol_shinan,
    },
    PrivacyProtocol: {
      path: '/shinan/PrivacyProtocol',
      component: PrivacyProtocol_shinan,
    },
    RechargeRegistrationProtocol: {
      path: '/shinan/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol_shinan,
    },
    VerifiedProtocol:{
      path: '/shinan/VerifiedProtocol',
      component: VerifiedProtocol_shinan,
    },
    RechargeRegistrationProtocolWx: {
      path: '/shinan/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx_shinan,
    },
    AccountCancellation: {
      path: '/shinan/AccountCancellation',
      component: AccountCancellation_shinan,
    },
    MerchantServices: {
      path: '/shinan/MerchantServices',
      component: MerchantServices_shinan,
    },
    OpenElePurseProtocol: {
      path: '/shinan/OpenElePurseProtocol',
      component: OpenElePurseProtocol_shinan,
    },
  },
   /*
  * 金昌慧停车
  * */
  jinchang: {
    PayProtocol: {
      path: '/jinchang/PayProtocol',
      component: PayProtocol_jinchang,
    },
    RegisterProtocol: {
      path: '/jinchang/RegisterProtocol',
      component: RegisterProtocol_jinchang,
    },
    QuickPaymentProtocol: {
      path: '/jinchang/QuickPaymentProtocol',
      component: QuickPaymentProtocol_jinchang,
    },
    FingerPrintProtocol: {
      path: '/jinchang/FingerPrintProtocol',
      component: FingerPrintProtocol_jinchang,
    },
    LongRentProtocol: {
      path: '/jinchang/LongRentProtocol',
      component: LongRentProtocol_jinchang,
    },
    SharedProtocol: {
      path: '/jinchang/SharedProtocol',
      component: SharedProtocol_jinchang,
    },
    PrivacyProtocol: {
      path: '/jinchang/PrivacyProtocol',
      component: PrivacyProtocol_jinchang,
    },
    RechargeRegistrationProtocol: {
      path: '/jinchang/RechargeRegistrationProtocol',
      component: RechargeRegistrationProtocol_jinchang,
    },
    VerifiedProtocol:{
      path: '/jinchang/VerifiedProtocol',
      component: VerifiedProtocol_jinchang,
    },
    RechargeRegistrationProtocolWx: {
      path: '/jinchang/RechargeRegistrationProtocolWx',
      component: RechargeRegistrationProtocolWx_jinchang,
    },
    AccountCancellation: {
      path: '/jinchang/AccountCancellation',
      component: AccountCancellation_jinchang,
    },
    MerchantServices: {
      path: '/jinchang/MerchantServices',
      component: MerchantServices_jinchang,
    },
    AuthorizedInformation: {
      path: '/jinchang/AuthorizedInformation',
      component: AuthorizedInformation_jinchang,
    },
    TripartiteSDK: {
      path: '/jinchang/TripartiteSDK',
      component: TripartiteSDK_jinchang,
    },
  },
   /* 金昌慧停车-运维 */
   jinchangOm: {
    PrivacyProtocol: {
      path: '/jinchangOm/PrivacyProtocol',
      component: PrivacyProtocol_jinchangOm,
    },

  }, 
}

module.exports = ProtocolRouters;



// WEBPACK FOOTER //
// ./src/router/protocol.js